



















import {Vue, Component, Prop} from 'vue-property-decorator';
import HoldQiDetails from "@/domainObjects/hold/HoldQiDetails";
import HoldTicket from "@/domainObjects/hold/HoldTicket";
import QiDetailForm from "@/view/shared-components/QiDetailForm.vue";

@Component({
    components: {QiDetailForm}
})

export default class HoldQiDetailsForm extends Vue {
    @Prop({required: true}) holdTicket!: HoldTicket;
    @Prop({required: true}) type!: String;

    holdQiDetails:HoldQiDetails;

    constructor(){
        super();
        this.holdQiDetails = new HoldQiDetails();
    }

    add(){
        this.holdTicket.holdQiDetails.unshift(this.holdQiDetails);
        this.holdQiDetails = new HoldQiDetails();
        for (let i = 0; i < this.holdTicket.holdQiDetails.length; i++){
            this.holdTicket.holdQiDetails[i].holdTicketId = this.holdTicket.holdTicketId;
        }
    }

    remove(i){
        this.holdTicket.holdQiDetails.splice(i, 1);
        if (this.holdTicket.holdQiDetails.length === 0){
            this.add()
        }
    }

}

